import { ReactNode } from 'react';
import { Tab, Tabs, useTheme } from '@mui/material';

export interface GridTabsHeaderProps {
  labels: string[];
  /** Each tab's `data-testid` and `data-cy`, from its index in `labels`. */
  getTabTestId?: (index: number) => string;
  selectedTab: number;
  onTabChange: (index: number) => void;
  children?: ReactNode;
  dataCy?: string;
}

// Controls sit beside the strip, not over it, so a strip wider than the room they leave scrolls.
export const GridTabsHeader = ({
  labels,
  getTabTestId,
  selectedTab,
  onTabChange,
  children,
  dataCy
}: GridTabsHeaderProps) => {
  const theme = useTheme();

  return (
    <div
      className="-m-5 flex items-center bg-[#F9F9F9]"
      data-cy={dataCy}>
      <div className="min-w-0 flex-1">
        <Tabs
          sx={{
            display: 'flex',
            alignItems: 'center',
            '.Mui-selected': {
              backgroundColor: 'white',
              color: theme.palette.primary.main
            }
          }}
          TabIndicatorProps={{
            sx: {
              backgroundColor: 'white',
              height: selectedTab <= labels.length - 1 ? 2 : 0,
              borderRadius: 1
            }
          }}
          value={selectedTab}
          variant="scrollable"
          scrollButtons="auto"
          onChange={(_e, index) => onTabChange(index)}>
          {labels.map((label, index) => (
            <Tab
              sx={{ textTransform: 'none', fontSize: '.8rem', color: 'black' }}
              key={index}
              label={label}
              data-testid={getTabTestId?.(index)}
              data-cy={getTabTestId?.(index)}
            />
          ))}
        </Tabs>
      </div>
      {children && <div className="inline-flex shrink-0 pr-4">{children}</div>}
    </div>
  );
};
